// src/context/CartContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { api, customerReqConfig } from "../../include/api";
import { getCustomer } from "../../include/function";

const CartCountContext = createContext();

export const CartCountProvider = ({ children }) => {
  const [customer, setCustomer] = useState(getCustomer()); // Initialize from getCustomer
  const [totalCartItems, setTotalCartItems] = useState(0);
  const [totalWishlistItems, setTotalWishlistItems] = useState(0);

  console.log("Current customer:", customer);

  //sync customer from storage whenever it might have changed (e.g. login/logout in another tab or flow)
  useEffect(() => {
    const syncCustomer = () => {
      const currentCustomer = getCustomer();
      if (JSON.stringify(currentCustomer) !== JSON.stringify(customer)) {
        setCustomer(currentCustomer);
      }
    };
   syncCustomer();
      const interval = setInterval(syncCustomer, 1000);
      return () => clearInterval(interval);
  }, [customer]); 
    
  // Function to fetch cart count
  const fetchCartCount = () => {
    if (customer && customer.id) {
      api
        .get(`/cart/?custId=${customer.id}`, customerReqConfig())
        .then((response) => {
          if (response.status === 200) {
            setTotalCartItems(response.data.data.totalItems || 0);
          }
        })
        .catch((err) => {
          console.error("Failed to fetch cart count:", err);
          setTotalCartItems(0);
        });
    } else {
      setTotalCartItems(0); // No customer → no cart
    }
  };

  // Function to fetch wishlist count
  const fetchWishlistCount = () => {
    if (customer && customer.id) {
      api
        .get(`/wishlist/?customerId=${customer.id}`, customerReqConfig())
        .then((response) => {
          if (response.status === 200) {
            const wishlistData = response.data.data.products || [];
            setTotalWishlistItems(wishlistData.length);
          }
        })
        .catch((err) => {
          console.error("Failed to fetch wishlist count:", err);
          setTotalWishlistItems(0);
        });
    } else {
      setTotalWishlistItems(0); // No customer → no wishlist
    }
  };

  // 👉 Refetch cart/wishlist whenever customer changes
  useEffect(() => {
    fetchCartCount();
    fetchWishlistCount();
  }, [customer]);

  console.log("Total Cart Items:", totalCartItems);

  return (
    <CartCountContext.Provider
      value={{
        totalCartItems,
        fetchCartCount, // in case you want to manually refresh
        totalWishlistItems,
        fetchWishlistCount,
        setTotalWishlistItems,
      }}
    >
      {children}
    </CartCountContext.Provider>
  );
};

// Custom hook
export const useCart = () => {
  const context = useContext(CartCountContext);
  if (!context) {
    throw new Error("useCart must be used within a CartCountProvider");
  }
  return context;
};
  